import React from "react";

export const SinUnidades = ({ longitud }) => {
  return (
    <>
      {longitud === 0 || !longitud ? (
        <h2 className="text-center mt-2">Sin unidades por el momento</h2>
      ) : (
        ""
      )}
    </>
  );
};
